import React, { useEffect, useRef, useState } from "react";
import googleicon from '../../Assets/Images/googleicon.png';
import stripeicon from '../../Assets/Images/stripeImg.png';
import loginIcon from '../../Assets/Images/logo.png';
import { formatAmount, formatUSNumber, MakeAxiosRequest,formatTextWithLineBreaks } from "../../utils/handler";
import { useForm, Controller } from "react-hook-form";
import { Link, Navigate, useNavigate, useParams } from 'react-router-dom';
import StripeContainer from './StripeContainer';
import Loader from '../../Components/loader/Loader';
import { Modal, Button } from 'react-bootstrap';
import { Helmet } from "react-helmet";

import paymentfailed from '../../Assets/Images/paymentfailed.png';
const WebViewModal = ({ url, show, handleClose }) => {
  return (
    <Modal show={show} onHide={handleClose} size="lg" >
     <Modal.Header>
     <button 
        type="button" 
        className="close-btn" 
        onClick={handleClose}
        >
            <span className="material-symbols-outlined">close</span>
        </button>
      </Modal.Header>
      <Modal.Body>
        <iframe
          src={url}
          title="WebView"
          width="100%"
          className="viewModal"
          height="600px"
          style={{ border: 'none' }}
        />
      </Modal.Body>
      
    </Modal>
  );
};


function InvoicePayment() {
    const navigate = useNavigate();
    const params = useParams();
    const [data, setData] = useState({});
    const [Invoicedata, setInvoiceData] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [isSuccess, setIsSuccess] = useState(false);
    const [modalShow, setModalShow] = useState(false);
    const [showModal, setShowModal] = useState(false); // Toggle modal visibility
    const [paymentError, setPaymentError] = useState(null);

    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [url, setUrl] = useState("");
    useEffect(() => {
        fetchData();
    }, []);

     const handleShow = async() => {

        try {
            const response = await MakeAxiosRequest("post", "/invoice/download", { invoice_uuid: params.key });

            if (response.status === 1) {
                if (response.data.base64Content) {
                    // Create a Blob from the base64 string
                    const byteCharacters = atob(response.data.base64Content);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'application/pdf' });

                    // Create a download link
                    const link = document.createElement('a');
                    const url = window.URL.createObjectURL(blob);
                    link.href = url;
                    link.setAttribute('download', response.data.invoiceNum + '.pdf'); // Customize the file name here
                    document.body.appendChild(link);
                    link.click();

                    // Clean up
                    link.remove();
                    window.URL.revokeObjectURL(url);
                    console.log('downloaded');
                    //setShowLoader(false);
                }
            } else {
                console.log(response);
            }
        } catch (error) {
            console.error("Error", error);
        }
            
    };
    const loadRazorpay = () => {
        return new Promise((resolve) => {
          const script = document.createElement('script');
          script.src = 'https://checkout.razorpay.com/v1/checkout.js';
          script.onload = () => {
            resolve(true);
          };
          script.onerror = () => {
            resolve(false);
          };
          document.body.appendChild(script);
        });
      };
      const handlePayment = async () => {
        const res = await loadRazorpay();
        if (!res) {
          alert('Failed to load Razorpay SDK');
          return;
        }
    console.log(data.currency);
        const options = {
          key: process.env.REACT_APP_RAZORPAY_USERNAME, // Add your Razorpay API key
          amount: data.amountToPay* 100,
          currency: data.currency,
          name: data.org_name,
          description: data.description,
          order_id: data.order_id, // Order ID generated in the backend
          handler: async function (response) {
            // Handle successful payment here            
            
             const result = await MakeAxiosRequest("post", "/submitrazorpay",{razorpay_payment_id:response.razorpay_payment_id,invoice_key: params.key});
           
             
              if (result.status == '1') {
                navigate('/payment/sucess/'+params.key)
              } else {
                navigate('/payment/error/'+params.key)
              }
          },
          prefill: {
            name: data.customerData.name,
            email: data.customerData.email,
            contact: data.customerData.phone_number,
          },
          notes: {
            address: data.customerData.address,
          },
          theme: {
            color: '#F37254',
          },
        };
        console.log(options);
        const paymentObject = new window.Razorpay(options);
        paymentObject.open();
      };
    const fetchData = async () => {
        setIsLoading(true)
        try {
            const response = await MakeAxiosRequest("post", "/invoice/makepayment/"+params.key,{key:params.key});
            // console.log(response)
            if (response.status == 1) {
                setData(response.data);
                setInvoiceData(response.data);
                
            }else if(response.status == 2) {
                setIsSuccess(true);
               
                setData(response.data);
                 
            }else if(response.status == 0) {
                //setIsSuccess(true);
                console.log(response);
                setPaymentError('There was an issue processing your payment. Please try again later.');
                 setShowModal(true);
                console.log(showModal);
            }else {
                console.log(response);
                
            }
            setIsLoading(false);
        } catch (error) {
            console.error("Error", error);
        }
    }
    const closeModal = () => {
        setModalIsOpen(false);
        setShowModal(false);
         setPaymentError(null);
    };
     const handleDownload = () => {
         
                if (data.downloadUrl) {
                    // Create a Blob from the base64 string
                    const byteCharacters = atob(data.downloadUrl);
                    const byteNumbers = new Array(byteCharacters.length);
                    for (let i = 0; i < byteCharacters.length; i++) {
                        byteNumbers[i] = byteCharacters.charCodeAt(i);
                    }
                    const byteArray = new Uint8Array(byteNumbers);
                    const blob = new Blob([byteArray], { type: 'application/pdf' });
    
                    // Create a download link
                    const link = document.createElement('a');
                    const url = window.URL.createObjectURL(blob);
                    link.href = url;
                    link.setAttribute('download', data.invoiceKey+'.pdf'); // Customize the file name here
                    document.body.appendChild(link);
                    link.click();
    
                    // Clean up
                    link.remove();
                    window.URL.revokeObjectURL(url);
                    console.log('downloaded');
                }
         
    };
    return (
        <>
        {isLoading ? (
                <Loader />
            ) : (
         <>
        {!isSuccess && 
      
<section className="wrapper-body payment-body inv-bill">
    <div className="container h-100">
        <div className="row h-100 align-items-center">
            <div className="col-12">
                <div className="row my-4">
                    <div className="col-md-9 col-lg-7 col-xl-6 mx-auto">
                        <div className="card card-wp">
                        <div className={`card-body ${data.org_logo != '' ? 'nvs-card' : ''}`}>

                                <div className="image-wrapper  d-flex justify-content-center ">
                                    {data.org_logo ? (
                                        <div className="invoice_logo">
                                        <img src={data.org_logo} alt="Organization Logo" className="img-fluid" />
                                        </div>
                                    ) : (
                                        <div className="org-name"><h2 className="primary fw-bold">{data.org_name}</h2></div>
                                    )}
                                </div>




                                <table className="tableWrapper w-100">
                                    <tbody className="w-100">


                                        <tr>
                                            <td className="inv-head pb-4" colspan="2"  style={{ width: '30%' }}>
                                                <h3 style={{ textAlign: 'center'}}>Invoice from {data.organizationDetails.name}</h3>
                                                <p >Billed to {data.customerData.name}</p>
                                                <p >Invoice Number: {data.invoiceID}</p>
                                            </td>
                                        </tr>

                                        {data?.razorPay != '1' &&
                                        <tr>
                                            <td className="add-card-inv px-4" colspan="2" >
                                                <div style={{ padding: '0px 10px', margin: '20px 0px 25px 0px'}}>
                                                    <StripeContainer  invoicedata={data}/>
                                                </div>
                                            </td>
                                        </tr>
                                        }


                                        <tr>
                                            <td className="card-inv px-4 " colspan="2">
                                                <table className="w-100 ">
                                                    <tr>
                                                    <td className="p-0">
                                                        <p>Invoice Date: <span style={{ color: '#333'}}>{data.invoiceDate}</span></p>
                                                    </td>
                                                    <td className="p-0" >
                                                        <p style={{ }}>Due Date: <span style={{ color: '#333'}}>{data.dueDate}</span></p>
                                                    </td>
                                                    </tr>
                                                   
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table className="tableWrapper w-100 ">
                                    <tbody>
                                    {data.description!=''  && <>
                                    <tr className="stepsBlocker tableBlocker">
                                        <td className="px-4" style={{ padding: '.295em' }} colSpan="2">
                                             <h5   className="pt-2 pb-1" style={{ color: '#1D1D1D', marginTop: '0px', marginBottom: '0px', fontSize: '1.275rem', fontWeight: 400 }}>Note</h5>
                                             <p className="desc" style={{ color: '#878787', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>{data.description.split('\n').map((line, index) => (
                                                <React.Fragment key={index}>
                                                {line}
                                                <br />
                                                </React.Fragment>
                                            ))}</p>
                                        </td>
                                    </tr>
                                    </> } 
                                    </tbody> 
                                </table>



                                <table className="tableWrapper w-100 ">
                                    <tbody>
                                        <tr className="stepsBlocker" colspan="3">
                                            <td className="px-4" style={{ padding: '.295em', paddingBottom: '0px' }} colSpan="2">
                                                <h5 className="pt-0" style={{ color: '#1D1D1D', marginTop: '0px', marginBottom: '0px', fontSize: '1.275rem', fontWeight: 400 }}>Invoice Items</h5>
                                            </td>
                                        </tr>
                                    </tbody> 
                                </table>


            <div className="inv-list">
                <table  className="tableWrapper w-100 ">
                    <tbody>
                        <tr>
                            <td className="px-4" colspan="2">
                                <table className=" price-list wp-tab res-tab w-100">
                                    <thead>
                                        <tr>
                                        <th scope="col" style={{ width: '50%',  padding: '0px'}}><h6 className="mb-3">Item Description</h6></th>
                                        <th scope="col" style={{ width: '15%',  padding: '0px'}}><h6 className="mb-3">Qty/Hrs</h6></th>
                                        <th scope="col" style={{ width: '15%',  padding: '0px',}}><h6 className="mb-3">Price</h6></th>
                                        <th scope="col" style={{ width: '20%',  padding: '0px'}}><h6 className="mb-3">Total</h6></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                    {data.invoiceItemList && data.invoiceItemList.map((item, index) => (
                                    <>
                                    <tr>
                                        <td colSpan='4'>
                                            <table className="desktop-sec" style={{ width: '100%'}}>
                                                <tr className="stepsBlocker" >
                                                    <td width="50%" data-label="Description"  style={{ width: '50%',  padding: '.295em'}}>
                                                        <h6  className="font-normal " style={{ color: '#878787', margin: 0, fontWeight: 400 }} dangerouslySetInnerHTML={{
                                                        __html: formatTextWithLineBreaks(
                                                        item.item_name
                                                        ),
                                                        }}></h6>
                                                    </td> 
                                                    <td  data-label="Qty/Hrs" style={{ width: '15%',  padding: '.295em'}}>
                                                        <h6  className="pt-0" style={{color: '#878787', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>{item.quantity}</h6>
                                                    </td>
                                                    <td data-label="Price"  style={{ width: '15%',  padding: '.295em'}}>
                                                        <h6 style={{ color: '#878787', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>{data.currencyLabel}{formatAmount(item.price)}</h6>
                                                    </td>
                                        <td data-label="Total" style={{ width: '20%',  padding: '.295em'}}>
                                                        <h6  style={{color: '#878787', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>{data.currencyLabel}{formatAmount(item.price * item.quantity)}</h6>
                                                    </td>
                                            </tr>
                                            </table>
                                        {/* Mobile-view */}
                                        <table className="mobile-sec" style={{ width: '100%'}}>
                                            <tr className="stepsBlocker" >
                                                <td data-label="Description"  style={{padding: '.295em'}}>
                                                    <h6  className="font-normal " style={{ color: '#878787', margin: 0, fontWeight: 400 }} dangerouslySetInnerHTML={{
                                                    __html: formatTextWithLineBreaks(
                                                    item.item_name
                                                    ),
                                                    }}></h6>
                                                </td> 
                                            </tr>
                                            <tr>
                                                <td  data-label="Qty/Hrs" style={{ padding: '.295em'}}>
                                                    <h6  className="pt-0" style={{color: '#878787', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>{item.quantity}</h6>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td data-label="Price"  style={{  padding: '.295em'}}>
                                                    <h6 style={{ color: '#878787', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>{data.currencyLabel}{formatAmount(item.price)}</h6>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td data-label="Total" style={{padding: '.295em'}}>
                                                    <h6  style={{color: '#878787', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>{data.currencyLabel}{formatAmount(item.price * item.quantity)}</h6>
                                                </td>
                                            </tr>
                                        </table>
                                        {/* Mobile-view */}
                                        </td>
                                    </tr>
                                    <tr className="border-hr">
                                        <td style={{ width: '100%', padding: '0', margin: '0px' }} colSpan="4">
                                            <hr style={{ border: 0, height: 0, borderTop: '1px dashed #DBDBDB', margin: '0', marginTop: '10px', marginBottom: '10px'  }} />
                                        </td>
                                    </tr>
                                    </>            
                                    ))}
                                    </tbody>
                                </table>


                                {/* <table className="price-list">
                                <tbody>
                                <tr>
                                <th scope="col" style={{ width: '50%',  padding: '0px'}}></th>
                                <th scope="col" style={{ width: '15%',  padding: '0px',  textAlign: 'center',}}><h6 className="mb-3">Qty/Hrs</h6></th>
                                <th scope="col" style={{ width: '15%',  padding: '0px', textAlign: 'end'}}><h6 className="mb-3">Price</h6></th>
                                <th scope="col" style={{ width: '20%',  padding: '0px'}}><h6 className="mb-3">Total</h6></th>
                                </tr>
                                {data.invoiceItemList && data.invoiceItemList.map((item, index) => (
                                <>
                                <tr className="stepsBlocker" >

                                <td  style={{  padding: '.295em'}}>
                                <h6  className="font-normal " style={{ color: '#878787', margin: 0, fontWeight: 400 }} dangerouslySetInnerHTML={{
                                    __html: formatTextWithLineBreaks(
                                    item.item_name
                                ),
                                }}></h6>
                                </td> 

                                {item.is_count === 1 && (
                                <>
                                <td>
                                <h6 className="pt-1" style={{ textAlign: 'center',  color: '#878787', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}><p className="m-0 text-center">{item.count}</p></h6>
                                </td>
                                <td style={{   padding: '0px' }} >
                                <h6 style={{ textAlign: 'end',color: '#878787', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}><p className="m-0 text-end">{data.currencyLabel}{formatAmount(item.price)}</p></h6>
                                </td>

                                <td style={{ textAlign: 'end', padding: '.295em' }}>
                                <h6  style={{color: '#878787', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>{data.currencyLabel}{item.is_count ? formatAmount(item.price * item.count) : formatAmount(item.price * item.hours)}</h6>
                                </td>
                                </>
                                )}

                                {item.is_count !== 1 && (
                                <>
                                <td style={{  padding: '.295em', paddingBottom: '0px' }} >
                                <h6 className="pt-1" style={{textalign: 'center', color: '#878787', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}><p className="m-0 text-center">{item.hours}</p></h6>
                                </td>
                                <td style={{ padding: '.295em', paddingBottom: '0px' }} >
                                <h6 style={{textAlign: 'end', color: '#878787', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}><p className="m-0">{data.currencyLabel}{formatAmount(item.price)}</p></h6>
                                </td>
                                <td style={{  textAlign: 'end', padding: '.295em' }}>
                                <h6 style={{ color: '#878787', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>{data.currencyLabel}{item.is_count ? formatAmount(item.price * item.count) : formatAmount(item.price * item.hours)}</h6>
                                </td>
                                </>
                                )}

                                </tr>
                                <tr>
                                <td style={{ width: '33%', padding: '0', margin: '0px' }} colSpan="4">
                                <hr style={{ border: 0, height: 0, borderTop: '1px dashed #DBDBDB', margin: '0', marginTop: '10px', marginBottom: '10px'  }} />
                                </td>
                                </tr>
                                </>            
                                ))}
                                </tbody>
                                </table> */}


                                </td>
                            </tr>
                        </tbody>
                    </table>
                             </div>


                                <table className="tableWrapper w-100">
                                    <tbody>
                                        <tr>
                                            <td className="pt-0">
                                                <table className="tableWrapper w-100 px-4">
                                                    <tbody>
                                                        <tr className="stepsBlocker tableBlocker">
                                                            <td style={{ width: '80%', padding: '0' }}>
                                                                <p style={{ textAlign: 'end', color: '#878787', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>Subtotal</p>
                                                            </td>
                                                            <td style={{ width: '20%', textAlign: 'end', padding: '.295em' }}>
                                                                <h6 style={{ color: '#1D1D1D', margin: 0, fontSize: '0.975rem', fontWeight: 700 }}>{data.currencyLabel}{formatAmount(data.subtotal)}</h6>
                                                            </td>
                                                        </tr>
                                                        <tr className="stepsBlocker tableBlocker">
                                                            <td style={{ width: '80%', padding: '.295em' }}>
                                                                <p style={{ textAlign: 'end', color: '#878787', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>{data.taxLabel}</p>
                                                            </td>
                                                            <td style={{ width: '20%', textAlign: 'end', padding: '.295em' }}>
                                                                <h6 style={{ color: '#1D1D1D', whiteSpace: 'nowrap', margin: 0, fontSize: '0.975rem', fontWeight: 700 }}>{data.currencyLabel}{formatAmount(data.taxamount)}{data.tax_percentage && ` (${data.tax_percentage}%)`}                                                                           </h6>
                                                                
                                                            </td>
                                                        </tr>
                                                       
                                                        <tr className="stepsBlocker tableBlocker">
                                                            <td style={{ width: '80%', padding: '.295em' }}>
                                                                <p style={{ textAlign: 'end', color: '#969696', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>Total</p>
                                                            </td>
                                                            <td style={{ width: '20%', textAlign: 'end', padding: '.295em' }}>
                                                                <h6 className="total-amd" style={{ color: '#3276fd', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>{data.currencyLabel}{formatAmount(data.total)}</h6>
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                                <td colSpan="2" style={{ width: '50%' }}><div style={{ width: '40%', margin: 'auto'}}>{data?.razorPay == '1' && <button className="btn btn-primary w-100 mt-4" onClick={handlePayment}>Pay</button>}
                                                                </div>
                                                            </td>
                                                        </tr>
                                                        {/* <tr className="stepsBlocker tableBlocker">
                                                            <td style={{ padding: '.295em' }} colSpan="2">
                                                                <h5 style={{ color: '#1D1D1D', marginTop: '0px', marginBottom: '0px', fontSize: '1.275rem', fontWeight: 400 }}>Billed To</h5>
                                                            </td>
                                                        </tr>
                                                        <tr className="billngData ">
                                                            <td colSpan="2" style={{ padding: '.295em'  }}>
                                                                <h6 style={{ color: '#656565', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>{data.customerData.name}</h6>
                                                            </td>
                                                        </tr>
                                                        <tr className="billngData">
                                                            <td colSpan="2" style={{ padding: '.295em' }}>
                                                                <h6 style={{ color: '#656565', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>{data.customerData.address}</h6>
                                                            </td>
                                                        </tr>
                                                        <tr className="billngData">
                                                            <td colSpan="2" style={{ padding: '.295em' }}>
                                                                <h6 style={{ color: '#656565', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>{data.customerData.city}, {data.customerData.state} {data.customerData.zip}</h6>
                                                            </td>
                                                        </tr>
                                                        <tr className="billngData">
                                                            <td colSpan="2" style={{ padding: '.295em' }}>
                                                                <h6 style={{ color: '#656565', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>{data.customerData.country}</h6>
                                                            </td>
                                                        </tr>
                                                        <tr className="billngData">
                                                            <td colSpan="2" style={{ padding: '.295em' }}>
                                                                <h6 style={{ color: '#656565', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>{data.customerData.email}</h6>
                                                            </td>
                                                        </tr>
                                                        <tr className="billngData">
                                                            <td colSpan="2" style={{ padding: '.295em' }}>
                                                                <h6 style={{ color: '#656565', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>{data.customerData.phone_number}</h6>
                                                            </td>
                                                        </tr>
                                                        <tr className="billngData mt-4">
                                                            <td className="pt-3" colSpan="2" style={{ padding: '.295em' }}>
                                                                <h5 style={{  color: '#1D1D1D', marginTop: '25px', marginBottom: '0px', fontSize: '1.275rem', fontWeight: 400 }}>Billed By</h5>
                                                            </td>
                                                        </tr>
                                                        <tr className="billngData">
                                                            <td colSpan="2" style={{ padding: '.295em' }}>
                                                                <h6 style={{ color: '#656565', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>{data.organizationDetails.name}</h6>
                                                            </td>
                                                        </tr>
                                                        <tr className="billngData">
                                                            <td colSpan="2" style={{ padding: '.295em' }}>
                                                                <h6 style={{ color: '#656565', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>{data.organizationDetails.email}</h6>
                                                            </td>
                                                        </tr>
                                                        <tr className="billngData">
                                                            <td colSpan="2" style={{ padding: '.295em' }}>
                                                                    <h6 style={{ color: '#656565', margin: 0, fontSize: '0.975rem', fontWeight: 400 }}>{data.organizationDetails.phone_number}</h6>
                                                            </td>
                                                        </tr>                    */}
                                                    </tbody>
                                                </table>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                                <table className="tableWrapper w-100">
                                    <tbody>
                                        <tr>
                                            <td className="footer">
                                                <p>If you have any questions, call at {data.organizationDetails.phone_number}</p>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>


                                

                                
                              
                            </div>
                        </div>
                        <p className="copyright-ftr">Copyright &copy; {new Date().getFullYear()} SwizzlePay. All rights reserved.</p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
        }
        {showModal && (
                        <>
                    <div className="modal-header border-0 p-0">
                    <button 
                      type="button" 
                      className="close-btn" 
                      onClick={closeModal}
                    >
                      <span className="material-symbols-outlined">close</span>
                    </button>
                  </div>
                  <div className="modal-body p-sm-4 p-3 text-center payment-fail">
                       <img className='w-100' src={paymentfailed} alt="" />
                        <h2>Payment Failed</h2>
                        <p>{paymentError?.message}</p>
                        
                      </div>
                    </>
                  )}
                      

        {isSuccess && 
         <div className="container ">
                <div className="row invoice_wrapperbody">

                    <div className="col-md-8 mx-auto">
                       
                        <div className="card paid-inv py-4">
                            <div className="card-body payment_body text-center">
                                <div className="image-wrapper">
                                    {data.org_logo ? (
                                        <img src={data.org_logo} alt="Organization Logo" className="img-fluid" />
                                       
                                    ) : (
                                        <div className="org-name"><h2 className="primary fw-bold">{data.org_name}</h2>
                                        </div>
                                    )}
                                </div>
                                {data.duedateover === 0 && (
                                    <div className="success-message d-flex justify-content-center align-items-center">
                                        <span className="material-symbols-outlined">check_circle</span>
                                        <h4 class="m-0">You have already paid the invoice.</h4></div>
                                  )}

                                    {data.duedateover === 1 && ( <>
                                     <div className="notsuccess-message">
                                        <span className="material-symbols-outlined">report</span>
                                        <h3>Can`t pay Now</h3>
                                    </div>
                                     <div className="notsuccess-message-info">
                                         <p className="gray">The due date for this invoice has passed.</p>
                                      </div> </>
                                    )}
                                   <div className="btn_align justify-content-center mt-4">
                                 {/* <Button variant="primary" onClick={() => handleShow()} className="btn btn-primary">
        Download Invoice
      </Button> */}

      <WebViewModal
        url={url}
        show={modalShow}
        handleClose={() => setModalShow(false)}
      />

                                   
                                <button className="btn btn-primary px-4" onClick={handleDownload}>Download Receipt</button>
                                          </div>
                            </div>

                        </div>

                    </div>

                </div>

            </div>
            }
        
        </>

    )}
    </>
)
}

export default InvoicePayment